import "./App.css";
import Home from "./components/Home/Home";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import { Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <div>
      <div className="door-container">
        <div className="left-door"></div>
        <div className="right-door"></div>
      </div>

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>

      <Footer />

      <>
        <div className="border left-border"></div>
        <div className="border right-border"></div>
      </>
    </div>
  );
};

export default App;
